import { Fragment } from "react";

import useAccountCreationYouthWarning from "./UseAccountCreationYouthWarning";

import Headings from "@usas/ui-web/components/headings/Headings";
import PrimaryButton from "@usas/ui-web/components/buttons/PrimaryButton";
import SecondaryButton from "@usas/ui-web/components/buttons/SecondaryButton";

import style from '../../../../LandingPages.module.css';

const AccountCreationYouthWarning = () => {
  const { onBackClicked, onContinueClicked } = useAccountCreationYouthWarning();

  return (
    <Fragment>
      <div className="row usas-extra-bottom-margin">
        <div className="col-xs-12 col-md-2" />
        <div className={['col-xs-12', 'col-md-8'].join(' ')}>
          <div className={["row", style.CenterPageContent].join(' ')}>  
            <Headings.H3>Important Notice</Headings.H3>
          </div>           
          <div style={{padding: '1em', borderRadius: '4px'}}  className={["usas-extra-top-margin usas-extra-bottom-margin", 'very-light-gray'].join(' ')}>
            <p>
              <strong>You&#39;re creating a child account for completing Education courses or viewing times and membership information.</strong>
            </p>
            
            <ul className="row usas-extra-bottom-margin" style={{listStylePosition: 'outside', paddingLeft: '1.9em', paddingRight:'2.2em'}}>
              <li>Your parent or guardian will be required to consent to finalize the account creation.</li>
              <li>You are creating a Login account for yourself.  Please answer all questions with your information.</li>
              <li>Creating a Login Account does not create a USA Swimming Athlete or Non-Athlete membership.</li>
            </ul>
          </div>

          <div className={["row", style.CenterPageContent].join(' ')}>
            <div className="col-xs-12 usas-extra-top-margin">
              <PrimaryButton onClick={onContinueClicked}>
                I Understand, Continue
              </PrimaryButton>
            </div>
            <div className="col-xs-12 usas-extra-top-margin">
              <SecondaryButton onClick={onBackClicked}>
                Back
              </SecondaryButton>
            </div>
          </div>
        </div>
        <div className="col-xs-12 col-md-2" />
      </div>
    </Fragment>
  );
};

export default AccountCreationYouthWarning;